import styled from '@emotion/styled';

type Props = {
  type: 'prefix' | 'suffix';
};

export const SearchIconContainer = styled.div<Props>((props) => {
  if (props.type === 'prefix') {
    return {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 8,
      marginRight: 18,
    };
  }
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  };
});
